import "../dialog/dialog.scss";
import DraggableModal from "./draggable-modal";
import ModernModal from "./modern-modal";


function ModalWrapper(props) {
    return (
        props.isDraggable ? <DraggableModal {...props} />
            : <ModernModal {...props} />
    )
}

export default ModalWrapper